import React from "react";
import CreatableSelect from "react-select/creatable";

const MultiSelectField = ({
  label,
  field,
  options,
  selectedValues,
  onChange,
}) => {
  return (
    <div className="form-section">
      <CreatableSelect
        isMulti
        classNamePrefix="select"
        value={selectedValues.map((val) => ({ value: val, label: val }))}
        onChange={(selected) => onChange(field, selected)}
        options={options}
        placeholder={`Select or add ${label.toLowerCase()}...`}
      />
    </div>
  );
};

export default MultiSelectField;
